module.exports = __webpack_public_path__ + "img/step44_a_printer_power_install_cable_cover.074d4765.png";